import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';

import { filter, withLatestFrom, map } from 'rxjs/operators';
import { Actions } from '../../actions';

import AppState from '../../state';
import User from '@common/types/user/user';
import { UpdateUser } from '../action-creators';
import { UPDATE_AGREEMENT } from '@webapp/store/terms/actions';
import { UpdateAgreement } from '@webapp/store/terms/action-creators';

export const updateUserAgreementEpic = (
  action$: Observable<Actions>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Actions, UpdateAgreement>(UPDATE_AGREEMENT),
    withLatestFrom(state$),
    filter(([_, state]) => !!state.user.profile?.id),
    map(([action, state]) => {
      const profile: Partial<User> = {
        ...state.user.profile,
        lastTermsAgreedDate: action.agreedDate,
      };

      return new UpdateUser(profile);
    })
  );
